const api = require ('@/api.js')
let ext_ = ``;
if (api && api.default && api.default.ext ) {
	ext_ = api.default.ext; 
}
module.exports = [
	{
		url_path : ext_ + '/sounds/alert_success.mp3',
		name 	 : 'success',
		type     : 'local'
	},
	{
		url_path : ext_ + '/sounds/alert.mp3',
		name 	 : 'alert',
		type     : 'local'
	},
	{
		url_path : ext_ + '/sounds/TechnnicalAlertDeviceOff.mp3',
		name 	 : 'alertDevice',
		type     : 'local'
	},
	{
		url_path : ext_ + '/sounds/sound_camera.mp3',
		name 	 : 'sound_camera',
		type     : 'local'
	},

];